import React, { useRef } from "react";
import { ALLOWED_RASTER_EXTENSIONS } from "../../utils/image/image-constants";
import { validateRasterImageFile } from "../../utils/image/image-file-utils";
import { sharedCompressImage } from "../../utils/shared-functions";
import { uploadRasterImage, deleteRemoteImageIfNeeded } from "../../utils/image/product-image-service";
import ImagePreviewRemove from "./ImagePreviewRemove";

export default function SingleRasterImageUpload({
    value,
    onChange,
    t,
    disabled = false,
    onBusyChange,
    onError,
}) {
    const inputRef = useRef(null);

    const handleSelectFile = async (event) => {
        const file = event.target.files?.[0];
        event.target.value = "";
        if (!file) return;

        const validation = validateRasterImageFile(file);
        if (!validation.valid) {
            onError?.(t(validation.key));
            return;
        }

        try {
            onBusyChange?.(true);
            const compressed = await sharedCompressImage(file);
            const uploadedUrl = await uploadRasterImage(file, compressed, t);
            onChange(uploadedUrl);
        } catch (err) {
            onError?.(err.message ?? t("alert_process_failed"));
        } finally {
            onBusyChange?.(false);
        }
    };

    const handleRemove = async () => {
        if (!value) return;
        try {
            onBusyChange?.(true);
            await deleteRemoteImageIfNeeded(value, t);
            onChange("");
        } catch (err) {
            onError?.(err.message ?? t("alert_process_failed"));
        } finally {
            onBusyChange?.(false);
        }
    };

    return (
        <div>
            {!value && (
                <label className="flex flex-col items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-slate-300 bg-slate-50 px-4 py-8 text-center cursor-pointer hover:border-ct-primary-400 hover:bg-ct-primary-50/30 transition">
                    <span className="text-2xl" aria-hidden>🖼️</span>
                    <span className="text-sm font-semibold text-slate-700">{t("label_seleccionar_imagen")}</span>
                    <span className="text-xs text-slate-500">{t("label_imagen_formatos_permitidos")}</span>
                    <span className="text-xs text-slate-500">{t("label_imagen_max_5mb")}</span>
                    <input
                        ref={inputRef}
                        type="file"
                        accept={ALLOWED_RASTER_EXTENSIONS.join(",")}
                        className="sr-only"
                        disabled={disabled}
                        onChange={handleSelectFile}
                    />
                </label>
            )}

            <ImagePreviewRemove
                value={value}
                alt={t("label_imagen_principal")}
                onRemove={handleRemove}
                disabled={disabled}
                removeLabel={t("label_eliminar_imagen")}
            />
        </div>
    );
}
